import React from "react";
import PropTypes from "prop-types";
import ExpertSkeletonCard from "../card/expert_skeleton_card";

function ExpertSkeletonPage({ numberOfCards, singleRow = false }) {
  const hideClass = (index) => {
    // Do some fancy footwork here to hide or display the proper number
    // of single-row skeleton cards based on number rendered and breakpoint.
    if (!singleRow) return "";

    switch (index) {
      case 1:
        return `d-none ${numberOfCards === 4 ? "d-sm-block" : "d-md-block"}`;
      case 2:
        return `d-none ${numberOfCards === 4 ? "d-md-block" : "d-xl-block"}`;
      case 3:
        return "d-none d-xl-block";
      default:
        return "";
    }
  };

  return (
    <>
      {Array(numberOfCards)
        .fill()
        .map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={hideClass(index)} key={index} style={{ gridRow: "span 4" }}>
            <ExpertSkeletonCard />
          </div>
        ))}
    </>
  );
}

ExpertSkeletonPage.propTypes = {
  numberOfCards: PropTypes.number.isRequired,
  singleRow: PropTypes.bool,
};

export default ExpertSkeletonPage;
